import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export default function FullLayout({ children }) {
  const auth = useSelector((state) => state.login);

  return (
    <Route render={() => auth.isAuthenticated ? (<Redirect to="/taskPlanner" />) : (<>{children}</>)} />
  );
};